import moment from '@/moment-gp'

export default {
  create({ displayName }, data) {
    return {
      // email:        email,
      displayName:  displayName,
      isOnline:     data.isOnline === undefined ? true : data.isOnline,
      // device:       data.userAgent,
      lastSeen:     moment.currentTimeServer('REALTIMEDB'),
      profilePic:   data.profilePic || null,
      goalId:       null,
      taskId:       null,
      memberId:     null, // Task member ID
      taskDuration: null,
      taskRecordingStartedAt: null,
      statusMessage: "status...",
      /*
      More status fields:
        - timezone: "America/New_York",
        - DND: false,
        - DNDMode: "",
        - DNDStart: 0,
        - DNDDuration: 0,

      member.$uid => {
        commitmentComplete:             Percent
        totalWorktimeToday:             Float
        completedWorktimeUntilLastStop: Float
        effortSessionStart:             Timestamp
        isActive:                       Boolean
      }

      visible: workspace.visible,
      availableFrom: new Date(1900, 1, 1, 8, 0, 0), // z.B. 8:00 Uhr morgen // TODO -> moment
      availableUntil: new Date(1900, 1, 1, 18, 0, 0), // z.B. 18:00 Uhr morgen // TODO -> moment
      onVacation: {
        from: new Date(2018, 7, 8, 0, 0, 0), // TODO -> moment
        to: new Date(2018, 7, 28, 0, 0, 0), // TODO -> moment
        message: "I'm on a boat"
      },

      // project related
      workHours: 14, // wie viele prozent der gesamtarbeitszeit hat der user zu diesem projekt beigetragen
      role: "owner",
      currentTask:
        status !== undefined && status.currentTask ? status.currentTask : "",
      currentTaskStarted: new Date() - 5000, // TODO -> moment
      currentTaskStatus: "paused",
      currentTaskPauseDuration: 20,
      currentTaskDuration: 10,
      */
    }
  },

  fields: {
    // email: { validate_bolt_type: 'String' }, // TODO: Should not be stored, GRDP
    displayName: { validate_bolt_type: 'String' },
    isOnline: { validate_bolt_type: 'Boolean' },
    // device: { validate_bolt_type: 'String' }, // TODO: weg damit
    lastSeen: { validate_bolt_type: 'Timestamp' },
    profilePic: { validate_bolt_type: 'String' },
    goalId: { validate_bolt_type: 'AnyID' },
    taskId: { validate_bolt_type: 'AnyID' },
    memberId: { validate_bolt_type: 'String' }, // ID can also be 'TEAM'
    taskDuration: { validate_bolt_type: 'Number' },
    taskRecordingStartedAt: { validate_bolt_type: 'Timestamp' },
    statusMessage: { validate_bolt_type: 'String' },
  }
};
